<template>
  <div>
    <button @click="modelpopupbuttonClick()" rel="btncreateModel" class="btn btn-primary btn-large btncreateModel">Schedule A Model</button>
    <div class="modal-mask" v-if="showmodel === true">
      <div class="modal-wrapper">
        <div class="modelpopContainer">
          <section class="content">
            <div class="row">
              <div class="col-md-12">
                <a class="close-btn" @click="closeCreateModel()">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
                <div class="topSteps clearfix">
                  <div class="stepsheading stepsin">Create Job Schedule</div>
                  <div ref="step1arrow" class="CreatelModelstep1 stepsin" v-on:click="setstep(2)" v-bind:class="(step >= 1) ? 'active' : ''">
                    <span>Step 1</span>
                    <i></i>
                  </div>
                  <div ref="step2arrow" class="CreatelModelstep2 stepsin" v-on:click="setstep(2)" v-bind:class="(step >= 2) ? 'active' : ''">
                    <span>Step 2 </span>
                    <i></i>
                  </div>
                  <div ref="step3arrow" class="CreatelModelstep3 stepsin" v-on:click="setstep(3)" v-bind:class="(step3) ? 'active' : ''">
                    <span>Step 3 </span>
                    <i></i>
                  </div>
                </div>
                <div class="">
                  <!-- Input Addons -->
                  <div>
                    <!-- with icons from font awesome -->
                    <form @submit.prevent="formValid" method="POST" id="create-job-form">
                      <div class="error text-danger" v-if="(popmsgVisible)">{{ popinmessage }}</div>
                      <div class="createmodelStep1 scheduling-step1" v-if="step1">
                        <div class="col-md-6 scheduling-colA">
                          <!-- <input ref="filecomp" id="myfilecsv" class="csvupload" type="file" @change="onmyFileChange" multiple="false"> -->
                          <label>Name
                            <small> &nbsp; &nbsp;&nbsp; e.g. Monster | FR | Apply Start | 010117 - 310317</small>
                          </label>
                          <div class="input-group">

                            <input class="form-control" v-model="name" data-vv-name="name" name="name" v-validate="'required'" :class="{'input': true, 'error': errors.has('name') }" placeholder="Enter ..." type="text" data-vv-validate-on="input|blur|submit">
                          </div>
                          <div class="clear-fix">
                            <span v-show="errors.has('name')" class="error text-danger">{{ errors.first('name') }}</span>
                          </div>
                          <br>
                          <!-- select examples -->
                          <div class="form-group" id="aclient">
                            <label>Client</label>
                            <select class="form-control" v-on:change="selectedClient(soption)" v-model="soption" data-vv-name="client" name="client" v-validate="'required'" :class="{'input': true, 'error': errors.has('client') }" data-vv-validate-on="input|blur|submit">
                              <option v-for="(option, index) in res" v-bind:value="index" :key="option.clientname.name">
                                <!-- v-model="key" :key="key"> -->
                                {{ option.clientname.name }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label>Country</label>
                            <select ref="selcountries" :disabled="market.length == 0" required v-model="selectedMarket" class="form-control" value="label" v-on:change="setselectedMarket()" data-vv-name="market" name="market" v-validate="'required'" :class="{'input': true, 'error': errors.has('market') }" data-vv-validate-on="blur|submit">
                              <option value="label" disabled>Select a Country</option>
                              <option v-for="(countries, key) in market" v-bind:value="key" :key="countries.name">{{countries.name}}</option>
                            </select>
                          </div>
                          <br />
                          <div v-if="selectedMarketSubmit" class="form-group">
                            <label>KPI</label>
                            <div class="clear-fix">
                              <span class="error text-danger" style="display:none">Please select a KPI</span>
                            </div>
                            <div class="kpiCheckbox checkbox">
                              <span v-for="(kpi, index) in kpi" v-bind:key="index">

                                <input :id="kpi" type="checkbox" name="" class="" v-bind:value="kpi" v-on:change="setselectedKpi()" v-model="selectedKpi">
                                <label :for="kpi">{{kpi}}</label>
                              </span>
                            </div>
                          </div>
                          <div v-if="customerType.length !== 0">
                            <label>Customer Type</label>
                            <div class="clear-fix">
                              <span class="error text-danger" style="display:none">Please select a Customer Type</span>
                            </div>
                            <div class="kpiCheckbox checkbox">
                              <span v-for="(customerType, index) in customerType" v-bind:key="index">
                                <input :id="customerType.value" type="checkbox" name="" class="" v-bind:value="customerType.value" v-model="selectedcustomerType">
                                <label :for="customerType.value">{{customerType.name}}</label>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 scheduling-colB">

                          <div class="form-group" id="aclient">
                            <label>Scheduling Frequency</label>
                            <select class="form-control" v-validate="'required'" v-model="selectedFrequency">
                              <option v-for="(schedulingFreqency) in schedulingFreqency" v-bind:value="schedulingFreqency" :key="schedulingFreqency">
                                <!-- v-model="key" :key="key"> -->
                                {{ schedulingFreqency }} Day(s)</option>
                            </select>
                          </div>

                          <div class="form-group clearfix datepicker">

                            <label>Start Date</label>
                            <div class="clear-fix datechecker">
                              <span>Please enter a future or current date</span>
                            </div>
                            <datepicker v-bind:value="schedulingStartDate" v-model="schedulingStartDate" calendar-button calendar-button-icon="fa fa-calendar" placeholder="Enter Start Date"></datepicker>
                          </div>
                          <div class="scheduleinputfeild">
                            <label>Re-Occurrence</label>
                            <div class="input-group">
                              <input class="form-control" v-model="reoccurrences" name="reoccurrences" v-validate="'required'" :class="{'input': true, 'error': errors.has('reoccurrences') }" placeholder="Enter ..." type="number" data-vv-validate-on="input|blur|submit">
                            </div>
                            <div class="clear-fix">
                              <span v-show="errors.has('reoccurrences')" class="error text-danger">{{ errors.first('reoccurrences') }}</span>
                            </div>
                          </div>
                          <div class="scheduleinputfeild">
                            <label>Data Range</label>
                            <div class="input-group">
                              <input class="form-control" v-model="datarange" name="datarange" v-validate="'required'" :class="{'input': true, 'error': errors.has('datarange') }" placeholder="Enter ..." type="number" data-vv-validate-on="input|blur|submit">
                            </div>
                            <div class="clear-fix">
                              <span v-show="errors.has('datarange')" class="error text-danger">{{ errors.first('datarange') }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="createmodelStep2" v-if="step2">
                        <div class="form-group">
                          <label>Data Source</label>
                          <div ref="datasourceinfo" class="datasourceinfo">{{datasourceinfo}}</div>
                          <div class="lookbackradio" v-for="datasourcetype in datasourcetype" v-bind:key="datasourcetype.value">
                            <input type="radio" v-bind:id="datasourcetype.name" v-bind:value="datasourcetype.value" checked v-model="datasourceSelected" @change="setdatasourceMessage(datasourcetype.message)" />
                            <label :for="datasourcetype.name">{{datasourcetype.name}}</label>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Week Commencing Day</label>
                          <select required v-model="commencingDay" class="form-control" value="label" data-vv-name="week" name="week">
                            <option value="label" disabled>Select a commencing day of week</option>
                            <option v-for="(week, key) in week" v-bind:value="(key + 1)" :key="week.key">{{week}}</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Lookback Window</label>
                          <div v-for="lookback in lookback" class="lookbackradio" :key="lookback.key">
                            <input type="radio" v-bind:id="(lookback)" v-model="lookbackSelected" v-bind:value="lookback" v-bind:checked="lookbackSelected === 'No lookback window' ? true : false " />
                            <label v-bind:for="lookback">{{lookback}}</label>
                          </div>
                        </div>
                      </div>
                      <div class="createmodelStep3" v-if="step3">
                        <div class="form-group">
                          <label class="display-block">Report Type</label>
                          <div v-for="reporttype in reporttype" v-bind:key="reporttype.key" class="lookbackradio">
                            <input type="radio" v-bind:id="(reporttype.name)" v-model="reporttypeSelected" v-bind:value="reporttype.value" />
                            <label v-bind:for="reporttype.name">{{reporttype.name}}</label>
                          </div>
                        </div>
                        <div class="form-group">
                          <Label>Channel Grouping Method</Label>
                          <div v-if="selectedMarketSubmit" class="channel-grouping-msg">Latest master-channel-groupings file was uploaded by
                            <b>{{ chusername }} on {{ chagroupingdate }}</b>
                            <a id="downloadchannelgrouping" style="visibility:hidden" class="btn btn-lrg btn-primary download-channel-grouping">Download Latest</a>
                          </div>
                          <div class="lookbackradio">
                            <input name="channel-grouping" type="radio" id="chg-master" value="master" v-model="channelgroupings">
                            <label for="chg-master">Use existing master channel grouping file</label>
                          </div>
                          <div class="lookbackradio">
                            <input name="channel-grouping" type="radio" id="chg-new" value="new" v-model="channelgroupings">
                            <label for="chg-new">Upload job specific channel grouping file</label>
                          </div>
                          <div class="lookbackradio">
                            <input name="channel-grouping" type="radio" id="chg-newmaster" value="newmaster" v-model="channelgroupings">
                            <label for="chg-newmaster">Upload a new master channel grouping file</label>
                          </div>
                          <div v-if="channelgroupings === 'new' || channelgroupings === 'newmaster'">
                            <label>Channel Grouping CSV file</label>
                            <!-- <input class="csvupload" type="file" @change="onFileChange" multiple="false" required> -->
                            <div class="upload-btn-wrapper">
                              <!-- <button class="btn btn-primary btn-large">Upload a file</button> -->
                              <input ref="filecomp" id="myfilecsv" class="csvupload" type="file" @change="onmyFileChange" multiple="false" required>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Createjob-btnswrapper clearfix">
                        <button id="Prevcreatejotbtn" @click="gotoBackStep()" type="button" class="btn btn-primary btn-large" v-if="(step !== 1)">Previous Step</button>
                        <button ref="buttoncreatejob" id="createjotbtn" type="submit" class="btn btn-primary btn-large" v-bind:class="(submit) ? 'enabled' : 'disabled'" v-if="(step === 3)">Create Model</button>
                        <button id="Nextcreatejotbtn" @click="gotoNextStep()" type="button" class="btn btn-primary btn-large" v-if="(step < 3)">Next Step</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
jQuery = $
var moment = require('moment')
import Vue from 'vue'
import VeeValidate from 'vee-validate'
// import DatePicker from 'vue2-datepicker'
// import Simplert from 'vue2-simplert'
import Datepicker from 'vuejs-datepicker'
// var dateparse = require('date-fns/parse')
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// var areRangesOverlapping = require('date-fns/are_ranges_overlapping')
// var differenceInDays = require('date-fns/difference_in_days')
// var res = require('../../../static/json/clientdata.json')
// res = res['client']
// var userchk = window.localStorage.getItem('user')
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

Vue.use(VeeValidate, config)
global.jQuery = require('jquery')
var jQuery = global.jQuery
window.jQuery = jQuery
export default {
  props: ['showmodelprop'],
  data () {
    return {
      datasourceinfo: 'datasourceinfo info',
      uploadedfile: '',
      postURL: '',
      step: 1,
      step1: true,
      step2: false,
      step3: false,
      showmodel: this.showmodelprop,
      popmsgVisible: false,
      popinmessage: '',
      name: '',
      downloadChannelGroupingfile: '',
      res: [],
      customerType: [],
      schedulingFreqency: 0,
      schedulingStartDate: '',
      currentscheduled: 0,
      reoccurrences: 0,
      datarange: 0,
      enableScheduling: false,
      time1: '',
      time2: '',
      start_date: '',
      end_date: '',
      market: [],
      countries: [],
      selectedMarket: [],
      selectedcustomerType: [],
      selectedFrequency: 0,
      soption: [],
      key: [],
      kpi: [],
      selectedType: [],
      selectedKpi: [],
      client: '',
      formreturn: '',
      submit: false,
      selectedMarketSubmit: '',
      modelname: 'modelname',
      week: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      commencingDay: 0,
      datasourcetype: [],
      datasourceSelected: 0,
      lookback: ['No lookback window', '30 Days', '60 Days', '90 Days'],
      lookbackSelected: 'No lookback window',
      daysinlookback: 0,
      channelgroupings: 'master',
      csvfilestring: '',
      reporttype: ['last-click-vs-bayesian', 'last-click'],
      reporttypeSelected: 'last-click-vs-bayesian',
      chusername: '',
      chagroupingdate: ''
    }
  },
  watch: {
    data: function () {
      // Clear previously selected values
    },
    selectedMarket: function () {
      return // this.selectedMarket
    },
    showmodel: function () {
      return this.showmodel
    }
  },
  inject: ['$validator'],
  aclient: 'options',
  components: {
    // Simplert,
    Datepicker
  },
  computed: {
    datetime () {
      return new Date()
    },
    formData () {
      return {
        name: this.name
      }
    }
  },
  methods: {
    onmyFileChange () {
      var self = this
      var theFormFile = this.$refs.filecomp.files[0]
      $.ajax({
        type: 'PUT',
        url: self.postURL,
        // Content type must much with the parameter you signed your URL with
        contentType: 'binary/octet-stream',
        // this flag is important, if not set, it will try to send data as a form
        processData: false,
        // the actual file is sent raw
        data: theFormFile,
        beforeSend: function () {
          self.$pingpong.displayLoader()
          jQuery('#createjotbtn').attr('disabled', 'disabled')
          jQuery('#createjotbtn').removeClass('enabled')
        },
        complete: function () {
          self.$pingpong.hideloader()
          jQuery('#createjotbtn').removeAttr('disabled')
          jQuery('#createjotbtn').addClass('enabled')
        },
        success: function (data) {
          // data = data['output']
          // self.uploadedfile = data.filepath
          console.log('file uploaded')
        },
        error: function () {
          alert('File NOT uploaded')
          console.log(arguments)
        }
      })
    },
    getSinedURL () {
      var self = this
      var outputurl = ''
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/urltoupload',
        data: { client: self.client, market: self.selectedMarketSubmit },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          // jQuery('.spinner').show()
        },
        complete: function () {
          // jQuery('.spinner').hide()
        },
        success: function (data) {
          data = data['output']
          self.postURL = data.url
          let str = data.key
          // self.uploadedfile = data.key
          // self.uploadedfile =
          // str = str.substring(str.indexOf('/') + 1)
          // str = str.replace(/^\/+|\/+$/g, '')
          self.uploadedfile = str
          // self.awss3.headers = {'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data'}
          // self.postfeilds = data.signature
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
      console.log(outputurl)
      return outputurl
    },
    captureResponce () {
      // console.log(this.$route.params.showmodel)
    },
    gotoNextStep: function (event) {
      // console.log(this.step)
      if (this.step === 1 && this.validdateStep1() === false) {
        this.popmsgVisible = true
        this.popinmessage = 'Please fill in the blank fields'
        return
      }
      if (this.step === 2 && this.validdateStep2() === false) {
        this.popmsgVisible = true
        this.popinmessage = 'Please fill in the blank fields'
        return
      }
      this.step = this.step + 1
      this.setstep(this.step)
      this.popmsgVisible = false
    },
    gotoBackStep: function () {
      this.step = this.step - 1
      this.setstep(this.step)
    },
    validdateStep1: function () {
      // only validates if value is present
      let current = new Date()
      let pickerdate = this.schedulingStartDate
      current.toDateString()
      current = moment(current)
      pickerdate.toDateString()
      pickerdate = moment(pickerdate)
      let checkdate = pickerdate.isSameOrAfter(current, 'day')
      if (!checkdate) {
        jQuery('.datechecker').show()
        console.log('error Step1')
        return false
      }
      if (this.name !== '' && this.client !== '' && this.selectedMarketSubmit !== '' && this.selectedKpi.length !== 0 && this.selectedcustomerType.length !== 0 && this.selectedFrequency.length !== 0 && this.reoccurrences.length !== 0 && this.datarange.length !== 0) {
        return true
      } else {
        console.log('error Step1')
        return false
      }
    },
    validdateStep2: function () {
      // only validates if value is present
      if (this.commencingDay) {
        return true
      } else {
        console.log('error Step1')
        return false
      }
    },
    validdateStep3: function () {
      // only validates if value is present
    },
    setstep: function (step) {
      if (step === 1) {
        if (!this.validdateStep1) {
          console.log('error Step1')
          return
        }
        this.step1 = true
        this.step2 = false
        this.step3 = false
      } else if (step === 2) {
        if (!this.validdateStep2) {
          console.log('error Step2')
          return
        }
        this.step2 = true
        this.step1 = false
        this.step3 = false
        this.$refs.step1arrow.classList.add('enable')
        this.selchannels = ''
      } else if (step === 3) {
        this.step2 = false
        this.step1 = false
        this.step3 = true
        jQuery('.CreatelModelstep2').addClass('enable')
      }
    },
    closeCreateModel () {
      let self = this
      let confirmCloseModal = {
        title: 'Are you sure you want to close Create Model?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          jQuery('#create-job-form').trigger('reset')
          self.step = 1
          self.step1 = true
          self.step2 = false
          self.step3 = false
          self.showmodel = false
          self.$router.push({ path: '/DisplaySchedule', params: { 'showmodel': false }, query: { 'showmodel': false } })
          window.location.reload()
        }
      }
      this.$Simplert.open(confirmCloseModal)
    },
    modelpopupbuttonClick (event, type) {
      this.showmodel = true
    },
    downloadChannelGrouping (e) {
      // attr('href', 'data:application/csv;charset=utf-8,'+ encodeURI(data))
      // var downloadObj = $('#downloadchannelgrouping')
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetChannelGroupings',
        data: { client: self.client, market: self.selectedMarketSubmit },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data)
          // var blob = new Blob([data], { type: 'text/csv' })
          self.downloadChannelGroupingfile = '1'
          $('#downloadchannelgrouping').css({ visibility: 'visible' })
          $('#downloadchannelgrouping').attr(
            'href',
            'data:text/csv,' + data['channels-groupings']
          )
          $('#downloadchannelgrouping').attr('download', 'jobmaster.csv')
          // downloadObj.click()
          // return
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
    },
    onFileChange (e) {
      e.target.accept = '.csv'
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createfile(files[0])
    },
    createfile (file) {
      // var image = new Image()
      var reader = new FileReader()
      reader.onload = (e) => {
        console.log(e.target.result)
        this.csvfilestring = e.target.result
      }
      reader.readAsDataURL(file)
    },
    setdatasourceMessage (msg) {
      let dsmessage = msg
      this.datasourceinfo = dsmessage
    },
    selectedClient (value) {
      // Clear previously selected values
      // console.log(this.soption)
      // console.log(this.res[this.soption])
      this.market = []
      this.selectedMarket = []
      // Populate list of countries in the second dropdown
      console.log('error test')
      console.log(this.res[this.soption])
      this.market = this.res[this.soption].clientname.markets
      this.client = this.res[this.soption].clientname.name
      this.$refs.selcountries.value = 0
      this.selectedMarket = 0
      this.currentscheduled = this.res[this.soption].clientname.scheduled
      this.setselectedMarket()
      this.setselectedKpi()
      // this.setdatasourceMessage()
    },
    setselectedMarket: function () {
      this.kpi = []
      this.selectedKpi = []
      this.selectedMarketSubmit = this.res[this.soption].clientname.markets[this.selectedMarket].name
      if (this.selectedMarket !== undefined) {
        this.customerType = this.res[this.soption].clientname.markets[this.selectedMarket].customer_type
        this.datasourcetype = this.res[this.soption].clientname.markets[this.selectedMarket].data_source
        this.setdatasourceMessage(this.datasourcetype[0].message)
        this.reporttype = this.res[this.soption].clientname.markets[this.selectedMarket].report_type
        this.schedulingFreqency = this.res[this.soption].clientname.markets[this.selectedMarket].scheduling_frequency
        this.kpi = this.res[this.soption].clientname.markets[this.selectedMarket].kpi
        this.selectedKpi.push(this.kpi[0])
        // this.end_date = moment(
        this.chagroupingdate = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .channel_groupings_modified
        ).format('llll')
        this.chusername = this.res[this.soption].clientname.markets[this.selectedMarket].channel_groupings_author
        this.chusername = this.chusername.split('-')[0]
        $('#downloadchannelgrouping').css({ visibility: 'visible' })
        this.downloadChannelGrouping()
      }
    },
    setselectedKpi () {
      if (this.selectedKpi.length !== 0) {
        this.submit = true
      } else {
        this.submit = false
      }
      return this.selectedKpi
    },
    getData () {
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetLookupTable',
        data: {
          'scheduled': 1
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // jQuery('.dataspinner').show()
          self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data['lookup-data'])
          self.res = data
          console.log(self.res)
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaydownloadError()
        }
      })
    },
    displaypopup () {
      this.showmodel = false
      let obj = {
        title: 'Job Created',
        message: 'Your Job is created successfully',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close'
      }
      this.$Simplert.open(obj)
      //
    },
    displaypopuperr () {
      this.showmodel = false
      let err = {
        title: 'Error',
        message: 'Your Job is not created',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    displayLookupError () {
      let err = {
        title: 'Error',
        message: 'Please select a lower start date',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    displaydownloadError () {
      let err = {
        title: 'Error',
        message: 'File Error',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    popuponClose () {
      // this.$router.push('/Displayjob')
      // this.$router.push("/createjob")
      window.location.reload()
    },
    formValid: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (self.kpi.length > 0) {
            this.createAdministrator()
          } else {
            jQuery('.kpierror').show()
          }
        } else {
          return
        }
      })
    },
    createAdministrator: function () {
      // Create mock user id. Replace this with actual user in future
      this.user = window.localStorage.getItem('user')
      // var currentdate = moment.format('DD-MM-YYYY')
      this.schedulingStartDate = moment(this.schedulingStartDate, 'DD-MMM-YYYY').format('DD-MM-YYYY')
      let customertype = this.selectedcustomerType.join('')
      // this.time2 = moment(this.time2, 'DD-MMM-YYYY').format('DD-MM-YYYY')
      /*    var day = (60 * 60 * 24 * 1000)
              this.time1 = new Date(this.time1)
              this.time2 = new Date(this.time2)
              this.time1 = new Date(this.time1.getTime() + day)
              this.time2 = new Date(this.time2.getTime() + day) */
      var data = {
        name: this.name,
        'schedule_start_date': this.schedulingStartDate,
        'frequency': this.selectedFrequency,
        'recurrence': this.reoccurrences,
        'data_range': this.datarange,
        'user_id': this.user,
        'job_data': {
          client: this.client,
          selectedMarket: this.selectedMarketSubmit,
          selectedKpi: this.selectedKpi.join(','),
          wcd: this.commencingDay,
          lbw: this.daysinlookback,
          'channel_groupings': this.uploadedfile,
          'report_type': this.reporttypeSelected,
          'channel_grouping_type': this.channelgroupings,
          'customer_type': customertype,
          ds: this.datasourceSelected
        }
      }
      // var data = ''' + this.name + '':'' + this.client + '''' + this.selectedMarket + '''' + this.selectedKpi + '''' + this.time2 + '''
      // console.log(data)
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerCreateJobSchedule',
        data: JSON.stringify(data),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest()
          // Upload progress
          xhr.upload.addEventListener(
            'progress',
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total
                // Do something with upload progress
                console.log(percentComplete)
              }
            },
            false
          )
          // Download progress
          xhr.addEventListener(
            'progress',
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total
                // Do something with download progress
                console.log(percentComplete)
                if (percentComplete === 100) {
                  // t
                }
              }
            },
            false
          )
          return xhr
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
          // let currentPos = jQuery(window).scrollTop()
          // currentPos = currentPos + 100
          // jQuery('.spinner').css({ top: currentPos })
        },
        complete: function () {
          self.displaypopup()
          self.$pingpong.hideloader()
        },
        success: function (data) {
          console.log(data)
          console.log('success')
          jQuery('#create-job-form').trigger('reset')
          jQuery('.csvupload').val('')
          self.csvfilestring = ''
          // self.showmodel = false
          self.step = 0
          self.step1 = true
          self.step2 = false
          self.step3 = false
          // self.$router.push('/Displayjob')
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaypopuperr()
        }
      })
    }
  },
  created: function () {
    this.captureResponce()
  },
  mounted: function () {
    var self = this
    let userauth = window.localStorage.getItem('user')
    if (userauth === undefined || userauth === '') {
      self.$router.push('/login')
    }
    this.getData()
    this.getSinedURL()
  },
  Update: function () {
    this.getData()
  }
}
</script>

<style lang='scss' scoped>
.channel-grouping-msg {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: normal;
  color: green;
  position: relative;
  b {
    color: #444;
    font-weight: normal;
  }
  a.download-channel-grouping {
    position: absolute;
    right: 0;
    top: -28px;
    border: none;
    font-weight: bold;
  }
}

.h6,
h6 {
  font-size: 16px;
  font-weight: bold;
}

.display-block {
  display: block;
}

.labltimerange {
  margin-bottom: 10px;
  display: block;
}

.dateerror {
  display: block;
  clear: both;
}

.success .simplert__title,
.success .simplert__body {
  color: green !important;
}

.poperror .simplert__title,
.poperror .simplert__body {
  color: red !important;
}

.disabled {
  pointer-events: none;
}

.vdp-datepicker {
  float: left;
  width: 25%;
  max-width: 340px;
  i {
    font-size: 1.6em;
    color: green;
  }
}

.vdp-datepicker input[type='text'] {
  padding: 0 5px;
  height: 3em !important;
  cursor: pointer;
  margin-bottom: 10px;
}

.datetime-picker input {
  height: 4em !important;
}

.datepicker .input-group-addon {
  position: absolute;
  float: right;
  top: 0;
  right: 0;
  width: 55px;
  height: 34px;
  cursor: pointer;
}

.datepicker .input-group-addon i {
  top: 2px;
  right: 0;
  position: relative;
}

.checkbox label:first-child {
  margin-left: 0;
}

.checkbox label {
  margin-left: 20px;
}

.lookbackradio {
  position: relative;
  input {
    margin-right: 10px;
    position: relative;
  }
  label {
    margin-bottom: 10px;
    position: relative;
    top: -2px;
    font-weight: normal;
  }
}

.kpiCheckbox {
  input[type='checkbox'] {
    margin: 0;
    min-height: 20px;
    height: 20px;
  }
  label {
    margin-left: 20px;
    margin: 0;
  }
}

// .btncreateModel {
//   margin-bottom: 30px;
// }

// a.close-btn {
//   padding: 0 5px;
//   color: #000;
//   cursor: pointer;
//   position: absolute;
//   right: 15px;
//   top: 0px;
//   font-size: 30px;
//   line-height: 34px;
// }
// .topSteps {
//   margin-bottom: 20px;
//   display: table;
//   width: 100%;
// }
// .stepsheading {
//   background-color: #898989;
//   padding: 15px 30px;
//   font-size: 24px;
//   border-radius: 0px 0px 10px 0px;
//   color: #fff;
// }

// .topSteps .stepsin {
//   float: left;
//   margin: 0 7%;
//   span {
//     line-height: 64px;
//     display: inline-block;
//     margin: 0 0 0 0;
//     float: left;
//   }
// }
// #create-job-form {
//   padding: 20px;
// }

// .stepsin i {
//   background: url('../../..//static/img/modelarrow.svg');
//   display: inline-block;
//   height: 62px;
//   width: 64px;
//   background-size: contain;
//   background-repeat: no-repeat;
//   margin: 4px 0 0 0;
//   float: left;
// }
// .stepsin.active i,
// .stepsin.enable i {
//   background: url('../../..//static/img/modelarrow-col.svg');
//   background-size: contain;
//   background-repeat: no-repeat;
// }
// .topSteps .stepsin:first-child {
//   margin: 0;
// }

// .Createjob-btnswrapper {
//   text-align: right;
// }
// .createmodelStep1:after,
// .createmodelStep1:before,
// .createmodelStep3:after,
// .createmodelStep3:before,
// .createmodelStep2:after,
// .createmodelStep2:before {
//   display: table;
//   clear: both;
//   content: ' ';
// }

#create-job-form .input-group {
  width: 100%;
}
.form-control,
.scheduling-colB .input-group {
  width: 40% !important;
}
input.form-control.input {
  height: 3em;
}
select.form-control {
  background-color: #a7c35e;
  color: #fff;
}
.datasourceinfo {
  position: absolute;
  left: 15%;
  border: 1px solid #a7c35e;
  padding: 15px;
  top: 10px;
  border-radius: 10px;
  background-color: #fbfbfb;
}

// .createmodelStep2 {
//   position: relative;
//   .lookbackradio label {
//     top: 1px;
//   }
// }
.kpiCheckbox.checkbox span {
  display: block;
  margin-top: 10px;
}
.scheduling-colA,
.scheduling-colB {
  margin-top: 20px;
  min-height: 340px;
}
.scheduling-colA {
  border-right: 1px solid #ededed;
}
.scheduleinputfeild {
  margin-bottom: 20px;
}

.datepicker label {
  display: block;
}
.scheduling-step1 .vdp-datepicker {
  width: 100%;
}
.datechecker {
  width: 40%;
  color: red;
  display: none;
  line-height: 18px;
  margin-bottom: 9px;
}
.text-danger.error {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// Schedulejob.vue?6e10d5fe